<template>
  <div class="actionBar" style="z-index: 999">
    <div class="box">
      <img src="../assets/images/publicImg/profile_btn_customer.png" class="btn_tousu"
           @click="keFu">
      <img src="../assets/images/publicImg/btn_tousu.png" class="btn_tousu" @click="touSu">
      <img src="../assets/images/publicImg/btn_share.png" class="btn_share" @click="share">
<!--      <div class="btn_message buttonStyle" @click="btn_message">发消息</div>-->
      <div class="btn_baoming buttonStyle" @click="callPhone"
           v-if="module != '招工'">联系老板
      </div>
      <!--      <div class="btn_baoming buttonStyle" @click="apply" v-if="tenderFlag === 0 && signFlag === 1">报名</div>-->
      <div class="btn_baoming999 buttonStyle" @click="apply"
           v-if="tenderFlag === 0 && signFlag === 0 && type === 'biaoZhun'">报名
      </div>
      <!--      <div class="btn_baoming999 buttonStyle" @click="apply"-->
      <!--           v-if="tenderFlag === 0 && signFlag === 0 && type !== 'biaoZhun'">已报名-->
      <!--      </div>-->
      <!--      <div class="btn_baoming999 buttonStyle" @click="apply"-->
      <!--           v-if="tenderFlag === 1 && signFlag === 0 && type !== 'biaoZhun'">已报名-->
      <!--      </div>-->
      <!--      <div class="btn_baoming buttonStyle" @click="bid" v-if="tenderFlag === 1 && type === 'biaoZhun'">投标</div>-->
      <div class="btn_baoming buttonStyle" v-if="module == '招工'" @click="callPhone">拨打电话</div>
    </div>

    <van-dialog v-model="touSuShow" showCancelButton @confirm="confirmCompany" @cancel="cancel">
      <van-field
        class="touSuStyle"
        v-model="content"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入投诉理由（200字以内）"
        show-word-limit
      />
    </van-dialog>

    <van-popup v-model="popupShow">

      <div class="contact-div">

        <van-icon name="cross" @click="popupShow = false"/>

        <div class="contact-title">温馨提示</div>
        <div class="contact-info">直接电话联系老板，找活更快哦</div>

        <div class="contact-btn">
          <van-button plain round type="primary" color="#096CEFFF" @click="apply">立即报名</van-button>
          <van-button round type="primary" color="#096CEFFF" @click="callPhone">联系老板</van-button>
        </div>
      </div>

    </van-popup>

    <van-overlay :show="overlayShow" @click="overlayShow = false" :z-index="9999">
      <div>
        <img class="share-img" src="../assets/images/coins/share.png">
      </div>
    </van-overlay>

    <callBack :dataType="dataType" :dataId="projectId" ref="callBack"/>
  </div>
</template>

<script>
import { getCryptoPhone } from '@api/activity'
import { getProjectTenderFlag, userFeedback } from '@api/getJob'
import { signIn } from '@api/openTender'
import { callByCoin, onceCallCoins, getImByCoin } from '@api/integralMall'
import callBack from '@/components/callBack'

export default {
  name: 'actionBar',
  components: { callBack },
  props: ['projectId', 'type', 'module', 'phoneNumber', 'imId', 'detailData'],
  data () {
    return {
      tenderFlag: '', // 投标状态：0-未报名；1-已报名未投标；2-已投标
      signFlag: '', // 是否可报名：0-不可报名；1-可报名
      content: '',
      token: '',
      touSuShow: false,
      overlayShow: false,
      inApp: true,
      cryptoPhone: '',

      popupShow: false,
      dataType: undefined

    }
  },
  created () {
    this.dataType = this.module === '招工' ? 2 : 1
  },
  mounted () {
    // 通过ua标识判断
    var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息

    // 不在app内
    if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
      this.inApp = false
      if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
        //
        //   // 在微信中展示遮罩提示浏览器打开
        //   this.overlayShow = true
      } else {
        this.$utils.initApp(this.$route.fullPath, this.module)
      }
    }

    // 开始时间
    this.startTime = Date.now()

    this.token = localStorage.getItem('token')
    if (this.token && this.token !== 'undefined' && this.module === '找活') {
      this.getProjectTenderFlag()
    }

    if (this.token && this.token !== 'undefined') {
      this.getCryptoPhone()
    }

    // // 电话回调
    // this.$bridge.registerHandler('callBack', (data, responseCallback) => {
    //   this.showFeedback()
    // })

    // 初始化极光统计
    this.$jiguang.initCountEvent()
  },
  methods: {

    // 显示拨打电话反馈
    showFeedback () {
      this.$refs.callBack.showFeedback()
    },

    // 获取用户加密手机号（用于分享）
    getCryptoPhone () {
      getCryptoPhone().then(res => {
        if (res.data.code === 200) {
          this.cryptoPhone = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 判断是否已报名
    getProjectTenderFlag () {
      getProjectTenderFlag({
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.tenderFlag = res.data.data.tenderFlag
          this.signFlag = res.data.data.signFlag
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    keFu () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (this.token && this.token !== 'undefined') {
          this.$dialog.confirm({
            title: '联系客服',
            message: '是否拨打客服热线\n400-0900-190',
            confirmButtonColor: '#096CEF'
          })
            .then(() => {
              window.location.href = 'tel:400-0900-190'
            })
            .catch(() => {
              // on cancel
            })
        } else {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        }
      }
    },

    // 投诉
    touSu () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (this.token && this.token !== 'undefined') {
          this.touSuShow = true
        } else {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        }
      }
    },
    // 分享
    share () {

      // 判断是否点击，一秒内点击一次
      let that = this
      if (this.isShare) {
        return
      }
      this.isShare = true
      setTimeout(function () {
        that.isShare = false
      }, 1000)

      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (!this.token || this.token === 'undefined') {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        } else {
          let content = ''
          if (this.detailData.city) {
            content = this.detailData.city
          }
          if (this.detailData.name) {
            content = content + this.detailData.name
          }

          // 获取当前地址
          let fullPath = this.$route.fullPath
          fullPath = fullPath.substring(0,fullPath.indexOf('?')) + "?projectId=" + this.projectId

          let path
          if (this.module === '找活') {
            path = 'pages/getJob/info/index?id=' + this.projectId + '&cryptoMobile=' + this.cryptoPhone
          } else {
            path = 'pages/hireWorkers/info/index?id=' + this.projectId + '&cryptoMobile=' + this.cryptoPhone
          }

          const data = {
            city: localStorage.getItem('cityCode'),
            content: content,
            fileUrl: [this.detailData.headImg],
            visible: 1,
            type: this.module === '找活' ? 2 : 1,
            url: fullPath,
            path: path,
            imId: this.imId,
            projectId: this.projectId
          }

          let countId = this.module === '找活' ? 'h5_zhaohuo_share' : 'h5_zhaogong_share'
          // 获取极光统计所需数据
          this.$bridge.callHandler('getDeviceInfo', countId, response => {
            console.log('response:', response)
          })

          this.$bridge.callHandler('share', data, response => {
            console.log('response:', response)
          })
        }
      }
    },
    // 发消息
    btn_message () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (!this.token || this.token === 'undefined') {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        } else {

          onceCallCoins({
            dataType: this.module === '招工' ? 2 : 1,
            dataId: this.projectId
          }).then(res => {
            if (res.data.code === 200) {
              if (res.data.data.firstFlag === true) {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'h5_send_message_alert', response => {
                  console.log('response:', response)
                })
                this.$dialog.confirm({
                  title: '发消息',
                  message:
                    `发消息，需要支付${res.data.data.value}个邀工币。`,
                  confirmButtonColor: '#096CEFFF'
                })
                  .then(() => {
                    this.paymentIm()
                  })
                  .catch(() => {
                    // on cancel
                  })
              } else {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'h5_send_message', response => {
                  console.log('response:', response)
                })
                let browTime = parseInt((Date.now() - this.startTime) / 1000)
                let brow = this.module === '找活' ? 'h5_get_job_info_browser,找活信息,找活,' + browTime : 'h5_recruitment_info_browser,招工信息,招工,' + browTime
                // 初始化极光统计预览时长
                this.$jiguang.initBrowseEvent(brow)

                const data = {
                  imId: this.imId,
                  name: this.detailData.name
                }
                this.$bridge.callHandler('sendMessage', data, response => {
                  console.log('response:', response)
                })
              }
            } else {
              this.$toastMsg(res.data.msg)
            }
          })
        }
      }
    },
    // 点击报名按钮
    apply () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (!this.token || this.token === 'undefined') {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
          return
        }

        // 获取极光统计所需数据
        this.$bridge.callHandler('getDeviceInfo', 'h5_baoming', response => {
          console.log('response:', response)
        })
        signIn({
          projectId: this.projectId
        }).then(res => {
          if (res.data.code === 200) {
            if (res.data.data.isEnough === 0) {
              // 人数是否够：1-够；0-不够
              this.$dialog.confirm({
                title: '提示',
                message: '你的队伍规模不满足投标条件，无法报名，请添加人员。',
                confirmButtonText: '立即添加'
              }).then(() => {
                // 添加人员 和客户端交互
                this.$bridge.callHandler('orgParticipantList', response => {
                  console.log('response:', response)
                })
              }).catch(() => {
                // on cancel
              })
            } else {
              this.$toast.success('报名成功')
              this.getProjectTenderFlag()
              // this.$emit('refreshDetail')
            }
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }
    },

    // 投标
    bid () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (!this.token || this.token === 'undefined') {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
          return
        }
        const data = {
          title: '投标信息',
          url: `${process.env.VUE_APP_BASE_HOST}/bidPage?projectId=${this.projectId}`
        }
        this.$bridge.callHandler('newPage', data, response => {
          console.log('response:', response)
        })
      }
      // this.enterRouter('bidPage', {projectId: this.$route.query.projectId })}
    },
    cancel () {
      this.touSuShow = false
      this.content = ''
    },
    confirmCompany () {
      if (!this.content) {
        this.$toastMsg('请输入投诉理由')
        return false
      } else {
        // 获取极光统计所需数据
        this.$bridge.callHandler('getDeviceInfo', 'h5_feedback', response => {
          console.log('response:', response)
        })
        userFeedback({
          type: this.module === '找活' ? 3 : 2,
          id: this.projectId,
          content: this.content,
          module: this.module
        }).then(res => {
          if (res.data.code === 200) {
            this.$toastMsg('投诉成功')
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }
    },
    // 调用拨号功能
    callPhone () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, this.module)
        }
      } else {
        if (this.token) {
          onceCallCoins({
            dataType: this.module === '招工' ? 2 : 1,
            dataId: this.projectId
          }).then(res => {
            if (res.data.code === 200) {
              if (res.data.data.firstFlag === true) {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
                  console.log('response:', response)
                })

                this.$dialog.confirm({
                  title: '拨打电话',
                  message:
                    `拨打电话，需要支付${res.data.data.value}个邀工币。`,
                  confirmButtonColor: '#096CEFFF'
                })
                  .then(() => {
                    this.payment()
                  })
                  .catch(() => {
                    // on cancel
                  })
              } else {
                callByCoin({
                  dataType: this.module === '招工' ? 2 : 1, // 招工2，找活1
                  dataId: this.projectId
                }).then(res => {
                  if (res.data.code === 200) {
                    const phoneNumber = res.data.data.phone
                    const data = { phone: phoneNumber }
                    this.$bridge.callHandler('callPhone', data, response => {
                      console.log('response:', response)
                    })
                  }
                })
              }
            } else {
              this.$toastMsg(res.data.msg)
            }
          })
        } else {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        }
      }
    },
    payment () {
      callByCoin({
        dataType: this.module === '招工' ? 2 : 1,
        dataId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    paymentIm () {
      getImByCoin({
        dataType: this.module === '招工' ? 2 : 1,
        dataId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            this.$dialog.confirm({
              title: '发消息',
              message:
                '支付完成，您可以发消息',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'h5_send_message', response => {
                  console.log('response:', response)
                })
                let browTime = parseInt((Date.now() - this.startTime) / 1000)
                let brow = this.module === '找活' ? 'h5_get_job_info_browser,找活信息,找活,' + browTime : 'h5_recruitment_info_browser,招工信息,招工,' + browTime
                // 初始化极光统计预览时长
                this.$jiguang.initBrowseEvent(brow)

                const data = {
                  imId: this.imId,
                  name: this.detailData.name
                }
                this.$bridge.callHandler('sendMessage', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "../assets/css/mixin";

.van-dialog__message {
  //font-size: 20px;
  text-align: center;
  line-height: 30px;
}

.contact-div {
  width: 300px;
  padding: 12px 12px 20px 12px;
  text-align: center;

  .van-icon-cross {
    font-size: 16px;
    float: right;
  }

  .contact-title {
    font-size: 17px;
    padding-top: 14px;
  }

  .contact-info {
    padding: 26px 0 10px 0;
    font-size: 16px;
  }

  .van-button {
    margin: 0 10px;
    width: 110px;
    height: 32px;
  }
}

.actionBar {
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  box-shadow: 0px -5px 15px rgba(0, 0, 0, 0.08);
  position: fixed;
  bottom: 0;

  .van-popup {
    border-radius: 10px;
  }

  .box {
    display: flex;
    align-items: center;
    padding: 8px 12px 8px 14px;

    .btn_tousu {
      width: 28px;
      height: 44px;
      margin-right: 12px;
    }

    .btn_share {
      width: 28px;
      height: 44px;
      margin-right: 24px;
    }

    .buttonStyle {
      width: 120px;
      height: 32px;
      line-height: 32px;
      opacity: 1;
      border-radius: 50px;
      font-size: 15px;
      //@include add_size($font_size_16);
      text-align: center;
      color: #FFFFFF;
    }

    .btn_message {
      background: #37A1FFFF;
      margin-right: 8px;
    }

    .btn_baoming999 {
      margin-right: 8px;
      background: #ccc;
    }

    .btn_baoming {
      background: #096CEF;
      margin-left: 128px
    }
  }

  .touSuStyle {
    width: 90%;
    border: 1px solid #E1E1E1;
    padding: 10px;
    margin: 40px auto;
    background: rgba(255, 255, 255, 0.39);

    .van-field__control {
      font-size: 20px !important;
    }

    .van-cell {
      background: rgba(255, 255, 255, 0.39);
    }
  }
}
</style>
